import React, { useContext, useMemo } from 'react';
import { TranslatorContext } from '@jutro/locale';

import { Link } from '@jutro/components';
import { SG_AA_PREMIUM_PAGE_ACTION } from 'sg-adobe-analytics/AdobeAnalyticsConstants';
import CommonConstants from 'sg-common-constants';
import messages from './SgSpmDeclarationsBullets.messages';

function SgSpmDeclarationsBullets() {
    const translator = useContext(TranslatorContext);

    const adobeBaseValue = `${SG_AA_PREMIUM_PAGE_ACTION.LEVEL_1.DECLARATIONS}|${SG_AA_PREMIUM_PAGE_ACTION.LEVEL_2.TEXT}|`;

    const fraudBulletpointMessage = useMemo(() => {
        return (
            <>
                <span>{translator(messages.FraudBulletpoint)}</span>
                <Link
                    id="fraudPreventionLink"
                    href={CommonConstants.SAGA_LINKS.FRAUD_PREVENTING}
                    rel="noreferrer"
                    target="_blank"
                    adobeValue={`${adobeBaseValue}${SG_AA_PREMIUM_PAGE_ACTION.LEVEL_3.FRAUD}`}
                >
                    {translator(messages.FraudLink)}
                </Link>
                <span>).</span>
            </>
        );
    }, [translator]);

    return (
        <>
            <li id="offenceBulletpoint">{translator(messages.OffenceBulletpoint)}</li>
            <li id="fraudBulletpoint">{fraudBulletpointMessage}</li>
        </>
    );
}

export default SgSpmDeclarationsBullets;
